<template>
  <div class="test_card">
    <div :class="[fixedCtrl ? 'isFixed' :'','card_header clearfix']">
      <div class="test_number_info">
        <div class="test_info_item">
          <span>答案/题目：</span>
          <span>{{rankList.answerCount}}/{{rankList.questionCount}}</span>
        </div>
        <div class="test_info_item">
          <span>总分值：</span>
          <span>{{rankList.totalScore / 100}}</span>
        </div>
      </div>
      <div class="ctrl_btn_wrapper">
        <!--<span class="ctrl_item" v-if="rankList.status == 0" @click="triggerMode">{{answerEditorMode ? '答题卡编辑' : '答案编辑'}}</span>-->
        <span class="editor_mode_tips" v-show="answerEditorMode">文本框编辑中…</span>
        <span class="ctrl_item" v-show="!answerEditorMode" @click="addSubjectFn">新增大题</span>
        <span class="ctrl_item" v-show="!answerEditorMode" @click="exportStatus = true">开始布码</span>
        <span class="ctrl_item" v-show="!answerEditorMode" @click="changeAddAnswerMode">录入答案</span>
        <span class="ctrl_item" @click="$router.back(-1)">保存并退出</span>
      </div>
    </div>
    <div class="card_content">
      <div class="test_caption">
        <div class="test_title">
          <span>{{rankList.name}}</span>
          <!--<span class="revise" data-context="name" :data-value="rankList.name" @click="reviseData">修改</span>-->
        </div>
        <div class="subject_grade">
          <div class="subject_item">
            <span>科目：</span>
            <span>{{rankList.subject}}</span>
            <!--<span class="revise" data-context="subject" :data-value="rankList.subject" @click="reviseData">修改</span>-->
          </div>
          <div class="subject_item">
            <span>年级：</span>
            <span>{{rankList.grade}}</span>
            <!--<span class="revise" data-context="grade" :data-value="rankList.grade" @click="reviseData">修改</span>-->
          </div>
        </div>
        <div class="student_info-wrapper clearfix">
          <div class="student_info">
            <div class="class_name">
              <span class="header_card_label">班级：</span>
              <span class="header_card_border"></span>
              <span class="header_card_label">姓名：</span>
              <span class="header_card_border"></span>
            </div>
            <div class="class_name">
              <span class="header_card_label">考号：</span>
              <span class="header_card_border"></span>
            </div>
          </div>
          <div class="student_score">
            <div class="class_name">
              <span class="count_label">计分：</span>
              <span class="count_card_border"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="test_subject_list" v-if="rankList.sections != []">
        <div class="first_level" v-for="(section,index) in rankList.sections" :key="section.id">
          <div class="level_title">
            <span class="first_level_type">{{section.title}}</span>
            <!--<span class="score_value">(每题{{section.score}}分，共{{section.score * section.amount}}分)</span>-->
            <span class="score_value">(每空{{section.score / 100}}分，共{{section.totalScore / 100}}分)</span>
            <span
              class="revise"
              data-context="firstLevel"
              :data-index="index"
              :data-answer-id="section.id"
              @click="reviseData"
            >修改</span>
            <span
              style="color:#f00"
              class="revise"
              data-context="firstLevel"
              :data-index="index"
              :data-answer-id="section.id"
              @click="deleteBigShowModal"
            >删除</span>
            <span
              v-if="section.type==5&&answerEditorMode"
              class="revise revise01"
            >点击左边题目再点击右边对应的答案生成相同的颜色连成一组</span>
            <div class="judge_subject" v-if="section.type === 4 && answerEditorMode">
              <span class="set_answer_tips">整体答案设置</span>
              <Button
                class="judge_item"
                type="primary"
                @click="addJudgeAnswer({context:'all',msg:1,bigIndex:index})"
              >正确</Button>
              <Button
                class="judge_item"
                type="error"
                @click="addJudgeAnswer({context:'all',msg:2,bigIndex:index})"
              >错误</Button>
              <Button
                class="judge_item"
                type="default"
                @click="addJudgeAnswer({context:'all',msg:0,bigIndex:index})"
              >无答案</Button>
              <span class="answer_tips">点击小题可切换答案</span>
            </div>
            <!--<div class="judge_subject" v-if="section.type === 1 && answerEditorMode">-->
            <!--<Checkbox class="order_choice_checkbox" v-model="choiceOrder">自动批改时忽略排列顺序</Checkbox>-->
            <!--</div>-->
          </div>
          <!--<div class="second_level clearfix">-->
          <div class="new_second_level clearfix">
            <template
              class="new_detail_level"
              v-for="(list,num) in section.details"
              v-if="!answerEditorMode"
            >
              <div
                v-if="section.type!=5"
                :class="[section.type == 3 ? 'big_question_space' :'new_item_level']"
                v-for="(item,count) in list.items"
                :key="count"
                :style="{width:(screenWidth -190)/section.colCount*list.colTimes + 'px',height:[section.type == 3 ? defaultHeightBig :defaultHeightSmall]*list.rowTimes + 'px'}"
              >
                <span :class="[section.type == 3 ? 'big_question_num_pre' :'question_num_pre']">
                  <span v-if="rankList.mode === 1">{{list.questionNo}}</span>
                  <span v-if="rankList.mode === 0">{{num + 1}}</span>
                  <span v-if="list.questionOffset != 0">.{{item.questionOffset}}</span>
                  <span v-if="section.type == 3">({{list.score / 100}}分)</span>
                </span>
                <!--高度倍数大于1时的空格内分割线-->
                <div
                  class="inside_line_wrapper"
                  v-if="list.rowTimes > 1"
                  :style="{width:(screenWidth -190)/section.colCount*list.colTimes - [section.score != list.score ? 60 : 23] + 'px'}"
                  :data-question-no="list.questionNo"
                  :data-question-offset="item.questionOffset"
                  :data-answer-id="section.id"
                  :data-big-index="index"
                  :data-small-index="num"
                  :data-answer="item.answer"
                  :key="count"
                  @click.stop="showAttrEditor"
                >
                  <span
                    class="partition_line_inside"
                    :style="{marginTop:defaultHeightSmall + 'px'}"
                    v-for="n in list.rowTimes - 1"
                  ></span>
                  <span
                    class="answer_section_inside"
                    :style="{whiteSpace: 'inherit',textOverflow: 'inherit',width:(screenWidth -190)/section.colCount*list.colTimes - [section.score != list.score ? 60 : 10] + 'px'}"
                    v-if="section.type != 4"
                    :data-question-no="list.questionNo"
                    :data-question-offset="item.questionOffset"
                    :data-answer-id="section.id"
                    :data-big-index="index"
                    :data-small-index="num"
                    :data-answer="item.answer"
                    :key="count"
                    @click.stop="showAttrEditor"
                  >{{item.answer}}</span>
                </div>
                <!--<span class="partition_line_inside" v-if="list.rowTimes > 1" :style="{marginTop:defaultHeightSmall + 'px'}" v-for="n in list.rowTimes - 1"></span>-->
                <!--判断题-->
                <Icon
                  v-if="section.type == 4"
                  class="judge_icon"
                  style="border: none;"
                  :color="item.answer == 1 ? '#3982F8' : '#f00'"
                  :type="item.answer == 1 ? 'md-checkmark' : (item.answer == 2 ? 'md-close' : '')"
                  :data-question-no="list.questionNo"
                  :data-question-offset="item.questionOffset"
                  :data-answer-id="section.id"
                  :data-big-index="index"
                  :data-small-index="num"
                  :data-answer="item.answer"
                  :key="count"
                  @click="showAttrEditor"
                />
                <span
                  class="answer_section"
                  :style="{whiteSpace:[list.rowTimes > 1 ? 'inherit' : ''],textOverflow:[list.rowTimes > 1 ? 'inherit' : '']}"
                  v-if="section.type != 4 && list.rowTimes == 1"
                  :data-question-no="list.questionNo"
                  :data-question-offset="item.questionOffset"
                  :data-answer-id="section.id"
                  :data-big-index="index"
                  :data-small-index="num"
                  :data-answer="item.answer"
                  :key="count"
                  @click="showAttrEditor"
                >{{item.answer}}</span>
                <span
                  class="question_right_score"
                  v-if="section.type != 3 && section.score != list.score "
                >({{list.score / 100}}分)</span>
                <div
                  class="page_division_line"
                  :style="{width:screenWidth - 80 + 'px',borderBottomColor:'#00f',marginTop:section.type == 3 ? '408px' :  parseInt(defaultHeightSmall * list.rowTimes)+8  + 'px'}"
                  v-if="item.pageNo != (list.items[count + 1] ? list.items[count + 1].pageNo : 0 ||
                     section.details[num + 1] ? section.details[num + 1].items[0].pageNo : 0 ||
                     rankList.sections[index + 1] ?
                     rankList.sections[index + 1].details[0].items[0].pageNo : item.pageNo)"
                ></div>
              </div>
              <div
                v-if="section.type==5"
                v-for="(item,count) in list.items"
                :key="count"
                :id="count"
                class="clearfix line-box"
              >
                <div
                  class="line-subject line-left"
                  :data-question-no="list.questionNo"
                  :data-question-offset="item.questionOffset"
                  :data-answer-id="section.id"
                  :data-big-index="index"
                  :data-small-index="num"
                  :data-answer="item.answer"
                  :style="setCurrentColor(count)"
                  :key="count"
                >
                  <span v-if="rankList.mode === 1">{{list.questionNo}}</span>
                  <span
                    v-if="rankList.mode === 1 && list.questionOffset != 0"
                  >.{{item.questionOffset}}</span>
                  <span v-if="rankList.mode === 0">{{count + 1}}</span>
                </div>
                <div
                  class="line-subject line-right show-answer"
                  :style="getCurrentColor(item.questionOffset,item.answer,list.items)"
                >
                  <!--<span v-if="item.answer != ''">{{list.questionNo}}</span>-->
                  <span>{{getCurrentAnswer(item.questionOffset, item.answer, list.items, list.questionNo)}}</span>
                </div>
                <div
                  class="page_division_line"
                  :style="{width:screenWidth - 80 + 'px',borderBottomColor:'#00f',marginTop:section.type == 3 ? '408px' : parseInt(defaultHeightSmall * list.rowTimes)+8  + 'px'}"
                  v-if="item.pageNo != (list.items[count + 1] ? list.items[count + 1].pageNo : 0 ||
                     section.details[num + 1] ? section.details[num + 1].items[0].pageNo : 0 ||
                     rankList.sections[index + 1] ?
                     rankList.sections[index + 1].details[0].items[0].pageNo : item.pageNo)"
                ></div>
              </div>
            </template>
            <template
              class="new_detail_level"
              v-for="(list,num) in section.details"
              v-if="answerEditorMode"
            >
              <div
                v-if="section.type!=5"
                :class="[section.type == 3 ? 'big_question_space_answer' :'new_item_level_answer']"
                v-for="(item,count) in list.items"
                :key="count"
                :style="{width:(screenWidth -190)/section.colCount*list.colTimes + 'px',height:[section.type == 3 ? defaultHeightBig :defaultHeightSmall]*list.rowTimes + 'px'}"
              >
                <div :class="[section.type == 3 ? 'big_question_num' :'question_num']">
                  <span class="order_num">
                    <span v-if="rankList.mode === 1">{{list.questionNo}}</span>
                    <span v-if="rankList.mode === 0">{{num + 1}}</span>
                    <span v-if="list.questionOffset != 0">.{{item.questionOffset}}</span>
                  </span>
                  <!--行高为1倍，单行输入，不换行，超出隐藏-->
                  <input
                    v-if="section.type != 3 &&section.type != 4 && list.rowTimes == 1"
                    class="answer_ipt"
                    v-model="item.answer"
                    :data-question-no="list.questionNo"
                    :data-question-offset="item.questionOffset"
                    :data-answer-id="section.id"
                    :data-big-index="index"
                    :data-small-index="num"
                    :data-answer="item.answer"
                    @focus="showAttrEditor"
                    @blur="editorSmallAnswer(item.answer)"
                  />
                  <!--行高为>1倍，单行输入，自动换行，-->
                  <textarea
                    v-if="section.type != 3 &&section.type != 4 && list.rowTimes > 1"
                    class="answer_txt"
                    v-model="item.answer"
                    :data-question-no="list.questionNo"
                    :data-question-offset="item.questionOffset"
                    :data-answer-id="section.id"
                    :data-big-index="index"
                    :data-small-index="num"
                    :data-answer="item.answer"
                    @focus="showAttrEditor"
                    @blur="editorSmallAnswer(item.answer)"
                  />
                  <Icon
                    v-if="section.type == 4"
                    class="judge_icon"
                    :color="item.answer == 1 ? '#3982F8' : '#f00'"
                    :type="item.answer == 1 ? 'md-checkmark' : (item.answer == 2 ? 'md-close' : '')"
                    @click="addJudgeAnswer({context:'alone',bigIndex:index,smallIndex:num,questionOffset:item.questionOffset,questionNo:list.questionNo})"
                  />
                  <textarea
                    v-if="section.type == 3"
                    class="answer_txt"
                    v-model="item.answer"
                    :data-question-no="list.questionNo"
                    :data-question-offset="item.questionOffset"
                    :data-answer-id="section.id"
                    :data-big-index="index"
                    :data-small-index="num"
                    :data-answer="item.answer"
                    @focus="showAttrEditor"
                    @blur="editorSmallAnswer(item.answer)"
                  />
                </div>
                <div
                  class="page_division_line"
                  :style="{width:screenWidth - 80 + 'px',borderBottomColor:'#00f',marginTop:section.type == 3 ? '408px' :  '8px'}"
                  v-if="item.pageNo != (list.items[count + 1] ? list.items[count + 1].pageNo : 0 ||
                     section.details[num + 1] ? section.details[num + 1].items[0].pageNo : 0 ||
                     rankList.sections[index + 1] ?
                     rankList.sections[index + 1].details[0].items[0].pageNo : item.pageNo)"
                ></div>
              </div>
              <div
                v-if="section.type==5"
                v-for="(item,count) in list.items"
                :key="count"
                :id="count"
                class="clearfix line-box"
              >
                <div
                  class="line-subject line-left"
                  :data-question-no="list.questionNo"
                  :data-question-offset="item.questionOffset"
                  :data-answer-id="section.id"
                  :data-big-index="index"
                  :data-small-index="num"
                  :data-answer="item.answer"
                  :style="setCurrentColor(count)"
                  @click="getLeftColor(section.id,list.questionNo,item.questionOffset,count,index,num)"
                  :key="count"
                >
                  <span v-if="rankList.mode === 1">{{list.questionNo}}</span>
                  <span
                    v-if="rankList.mode === 1 && list.questionOffset != 0"
                  >.{{item.questionOffset}}</span>
                  <span v-if="rankList.mode === 0">{{count + 1}}</span>
                </div>
                <div
                  class="line-subject line-right set-answer show-answer"
                  @click="selectColor(count)"
                  :style="getCurrentColor(item.questionOffset,item.answer,list.items)"
                >
                  <span>{{getCurrentAnswer(item.questionOffset, item.answer, list.items, list.questionNo)}}</span>
                </div>
                <div
                  class="page_division_line"
                  :style="{width:screenWidth - 80 + 'px',borderBottomColor:'#00f',marginTop:section.type == 3 ? '408px' :  parseInt(defaultHeightSmall * list.rowTimes)+ 8  + 'px'}"
                  v-if="item.pageNo != (list.items[count + 1] ? list.items[count + 1].pageNo : 0 ||
                     section.details[num + 1] ? section.details[num + 1].items[0].pageNo : 0 ||
                     rankList.sections[index + 1] ?
                     rankList.sections[index + 1].details[0].items[0].pageNo : item.pageNo)"
                ></div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Modal
      class="add_subject"
      v-model="addSubjectStatus"
      width="500"
      title="编辑大题"
      @on-visible-change="addSubjectStatusChange"
    >
      <div class="model_item">
        <span class="label">题目类型</span>
        <Select
          class="model_value model_select"
          placeholder="题目类型"
          v-model="subjectType"
          @on-change="changeSubjectType"
        >
          <Option v-for="item in subjectTypeList" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </div>
      <div class="model_item">
        <span class="label">题目名称</span>
        <Input
          class="model_value subject_name"
          placeholder="如：一、选择题"
          @on-focus="selectedALl"
          v-model="subjectTitle"
        />
      </div>
      <div class="model_item">
        <span class="label">小题数</span>
        <Input
          @on-keyup="changeSubjectAmount"
          class="model_value subject_name"
          placeholder="小题数量"
          @on-focus="selectedALl"
          v-model="subjectAmount"
          ref="subjectAmountRef"
        >
          <span slot="append">道</span>
        </Input>
      </div>
      <div class="model_item">
        <span class="label">每空得分</span>
        <Input
          class="model_value subject_name"
          placeholder="得分只精确到小数点后两位"
          v-model="subjectScore"
          @on-focus="selectedALl"
          @on-blur="checkValue('add')"
        >
          <span slot="append">分</span>
        </Input>
      </div>
      <div v-show="lineSubject!=5" class="model_item">
        <span class="label">填写区大小</span>
        <Select class="model_value select_item" placeholder="填写区大小" v-model="colCount">
          <Option v-for="item in 4" :value="item" :key="item">一排{{item}}个</Option>
        </Select>
      </div>
      <!--<div class="model_item" v-if="subjectType == 2 && colCount == 1">-->
      <!--<span class="label">高度倍数</span>-->
      <!--<Select class="model_value select_item" placeholder="填写区大小" v-model="HeiMultiple">-->
      <!--<Option v-for="item in 4" :value="item" :key="item">{{item}}倍</Option>-->
      <!--</Select>-->
      <!--</div>-->
      <div v-show="lineSubject!=5" class="model_item">
        <span class="label">每小题填写区数</span>
        <Input
          class="model_value subject_name"
          placeholder="每小题填写区数"
          @on-focus="selectedALl"
          v-model="blockCount"
        />
      </div>
      <div class="model_footer" slot="footer">
        <div class="footer_ctrl">
          <span
            class="span_btn cancel_btn"
            ghost
            size="small"
            type="primary"
            @click="hideSubject"
          >取消</span>
          <span
            class="span_btn confirm_btn"
            size="small"
            type="primary"
            data-context="confirm"
            @click="addBigSubject"
          >确认</span>
        </div>
      </div>
    </Modal>
    <Modal
      class="add_subject"
      v-model="attrModalStatus"
      width="500"
      title="属性修改"
      @on-visible-change="changeAttrSwitch"
    >
      <div class="model_item">
        <span class="label">题号</span>
        <div class="model_value">{{bigIndex / 1 + 1}}-{{smallIndex / 1 + 1}}</div>
      </div>
      <div class="model_item" v-if="changeWidthStatus">
        <span class="label">答题区大小</span>
        <Select class="model_value select_item" placeholder="填写区大小" v-model="blockTimes">
          <Option v-for="item in 4" :value="item" :key="item">{{item}}倍</Option>
        </Select>
      </div>
      <div class="model_item" v-if="rowTimesStatus">
        <span class="label">答题区高度</span>
        <Select class="model_value select_item" placeholder="填写区大小" v-model="rowTimes">
          <Option v-for="item in 4" :value="item" :key="item">{{item}}倍</Option>
        </Select>
      </div>
      <div class="model_item">
        <span class="label">答题区数量</span>
        <Select class="model_value select_item" placeholder="每小题填写区数" v-model="blockCount">
          <Option v-for="item in 10" :value="item" :key="item">{{item}}个</Option>
        </Select>
      </div>
      <div class="model_item">
        <span class="label">本题每空得分</span>
        <Input
          class="model_value subject_name"
          placeholder="每个空格的分值"
          v-model="smallScore"
          @on-focus="selectedALl"
          @on-blur="checkValue('attr')"
        >
          <span slot="append">分</span>
        </Input>
      </div>
      <div class="model_footer" slot="footer">
        <div class="footer_ctrl clearfix">
          <span
            class="resize_btn_item_small resize_delete_btn"
            data-context="delete"
            @click.self="changeSmallAttr"
          >删除</span>
          <div class="confirm_wrapper">
            <span
              class="resize_btn_item_small resize_cancel_btn"
              @click="attrModalStatus = false"
            >取消</span>
            <span class="resize_btn_item_small" data-context="confirm" @click="changeSmallAttr">确定</span>
          </div>
        </div>
      </div>
    </Modal>
    <Modal v-model="reviseModalStatus" width="500" title="编辑">
      <Input
        class="editor_txt"
        type="textarea"
        v-model="txtValue"
        @on-focus="selectedALl"
        :rows="3"
        placeholder="在此输入……"
      />
      <div class="model_footer" slot="footer">
        <div class="footer_ctrl">
          <Button
            class="footer_btn_item cancel_btn"
            ghost
            size="small"
            type="primary"
            @click="reviseModalStatus = false"
          >取消</Button>
          <Button
            class="footer_btn_item confirm_btn"
            size="small"
            type="primary"
            @click="editorSmallAnswer"
          >确定</Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="exportStatus" width="550" title="开始布码">
      <p class="export_title">请确认答题卡编辑完成，</p>
      <!--<p class="export_tips">(如导出文档后再对此答题卡进行修改，则此文档点码将作废)</p>-->
      <p class="export_title">布码后，将不能再对答题卡题型进行编辑。</p>
      <div class="model_item export_num">
        <span class="label people_label">老师+学生人数</span>
        <Input class="total_num" v-model="txtValue" placeholder="老师+学生总数" @on-focus="selectedALl" />
      </div>
      <div class="model_footer" slot="footer">
        <div class="footer_ctrl">
          <Button
            class="footer_btn_item cancel_btn"
            ghost
            size="small"
            type="primary"
            @click="exportStatus = false"
          >取消</Button>
          <Button
            class="footer_btn_item confirm_btn"
            size="small"
            type="primary"
            @click="publishAnswerCard"
          >确定</Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="layingCodeStatus" width="550" title="提示">
      <p class="export_title">正在铺码中…</p>
      <!--<p class="export_tips">(如导出文档后再对此答题卡进行修改，则此文档点码将作废)</p>-->
      <p class="export_title">您可以录入答案</p>
      <p class="export_title">录入答案后可实现客观题自动批改</p>
      <div class="model_footer" slot="footer">
        <div class="footer_ctrl">
          <Button
            class="footer_btn_item cancel_btn"
            ghost
            size="small"
            type="primary"
            @click="layingCodeStatus = false"
          >取消</Button>
          <Button
            class="footer_btn_item confirm_btn"
            size="small"
            type="primary"
            @click="changeAddAnswerMode"
          >录入答案</Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="deleteBigStatus" width="550" title="提示">
      <p class="export_title">确认删除{{'“' + subjectTitle + '”'}}吗？</p>
      <div class="model_footer" slot="footer">
        <div class="footer_ctrl">
          <Button
            class="footer_btn_item cancel_btn"
            ghost
            size="small"
            type="primary"
            @click="deleteBigStatus = false"
          >取消</Button>
          <Button
            class="footer_btn_item confirm_btn"
            size="small"
            type="primary"
            data-context="delete"
            @click="addBigSubject"
          >确认</Button>
        </div>
      </div>
    </Modal>
    <Modal class="add_subject" v-model="colorModalStatus" width="510" title="选择颜色">
      <div class="color-list clearfix">
        <div
          v-for="(item, index) in colorList"
          :key="index"
          class="color-box"
          :style="{background: item.value}"
          :class="{'not-select': canChooseColor }"
          @click="selectActiveColor(item.id)"
          @mouseover="canChoose(item.id)"
          @mouseout="outChoose"
        >
          <span :class="[activeColor.id==item.id?'active-color':'']"></span>
        </div>
      </div>
      <div class="model_footer" slot="footer">
        <div class="footer_ctrl clearfix">
          <div class="confirm_wrapper confirm_wrapper01">
            <span class="resize_btn_item_small resize_btn_item_small01" @click="deleteColor">删除颜色</span>
            <span class="resize_btn_item_small" data-context="confirm" @click="changeColorModal">确定</span>
            <span class="resize_btn_item_small resize_cancel_btn" @click="cancelColor">取消</span>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { Message } from "iview";
import { messageAlert, selectedALLTxt } from "../common/common";
import {
  _addAnswerCard,
  _addBigSubject,
  _getAnswerCardDetail,
  _changeSmallAttr,
  _editorSmallAnswer,
  _publishAnswerCard,
  _getQuestionTypeList
} from "../api/api";

export default {
  data() {
    return {
      scoreFlag: true, //小数点位数不大于两位
      bigIndex: 0, // 大题的index
      smallIndex: 0, // 小题的index
      subjectType: 1,
      subjectTitle: "选择题",
      subjectAmount: 1,
      subjectScore: 1,
      HeiMultiple: 1, // 高度的倍数
      colCount: 4, //一行几列
      smallScore: 100, //分值，每小题得分
      blockTimes: 1, //填写区大小(倍数)
      rowTimes: 1, // 小题高度（倍数）站多少行，
      rowTimesStatus: false, // 小题 高度可调整
      changeWidthStatus: false, // 小题宽度可调整
      defaultHeightSmall: 74, // 小题的默认高度
      defaultHeightBig: 400, // 简答题的默认高度
      blockCount: 1, //每小题填写区数
      txtValue: "", // 编辑框内容
      context: "", //编辑框对象
      answerSheetId: 0, //答题卡编号
      answerSectionId: 0, //答题区编号
      questionNo: 1, //小题题号，题号从1开始编号
      questionOffset: 1, // 小题下子题号
      deleteBigStatus: false, // 删除大题modal
      exportStatus: false, // 导出文档弹框
      reviseModalStatus: false, // 修改的弹出框
      addSubjectStatus: false, // 新增大题弹框
      attrModalStatus: false, // 编辑某一大题弹框
      layingCodeStatus: false, // 铺码中提示框
      screenWidth: document.body.clientWidth, //屏幕宽度
      editorMode: false, // 新增大题模式
      answerEditorMode: false, // 答案编辑模式
      subjectTypeList: [], //题目类型列表
      rankList: {}, //
      judgeOrderNum: 0, //整体设置判断题答案序号
      choiceOrder: true, //选择题自动批改忽略顺序
      fixedCtrl: false, // 操作按钮吸顶
      currentNum: 0, // 小题所在页码
      lineSubject: -1,
      colorModalStatus: false, //颜色模态框
      initColorList: [
        {
          value: "rgba(157,41,50,0.5)",
          id: 0
        },
        {
          value: "rgba(239,223,174,0.5)",
          id: 1
        },
        {
          value: "rgba(120,146,98,0.5)",
          id: 2
        },
        {
          value: "rgba(73,65,102,0.5)",
          id: 3
        },
        {
          value: "rgba(237,89,53,0.5)",
          id: 4
        },
        {
          value: "rgba(217,182,16,0.5)",
          id: 5
        },
        {
          value: "rgba(23,124,176,0.5)",
          id: 6
        },
        {
          value: "rgba(179,109,97,0.5)",
          id: 7
        },
        {
          value: "rgba(212,242,232,0.5)",
          id: 8
        }
      ],
      colorList: [], //颜色列表
      activeColor: {
        id: -1,
        value: ""
      }, //当前选中的颜色和id
      questionIndex: -1, //连线题修改大题时获得index
      doingAnswer: [],
      canChooseColor: false,
      activeAnswer: "",
      rankIndex: -1,
      detailIndex: -1
    };
  },
  methods: {
    //      获取某个答题卡
    getAnswerCardDetail() {
      const self = this;
      //        setTimeout(window.location.reload(),100);
      _getAnswerCardDetail(self.answerCardId).then(res => {
        if (res.code === 0) {
          self.rankList = res.data;
          this.colorList = this.initColorList;
        }
      });
    },
    //      新增,修改大题确认
    addBigSubject(e) {
      if (this.subjectType == "5" && this.subjectAmount == "1") {
        messageAlert("小题数至少大于2", "warning");
        return false;
      }
      const self = this;
      let context = e.target.dataset.context;
      if (self.lineSubject == 5) {
        // self.colCount = 4;
        // self.blockCount = 1;
        var dataInfo = {
          answerSheetId: self.answerCardId,
          answerSectionId: self.editorMode ? 0 : self.answerSectionId,
          type: self.subjectType,
          title: self.subjectTitle,
          amount: 1,
          score: self.subjectScore * 100,
          colCount: 1,
          blockCount: 1
        };
      } else {
        var dataInfo = {
          answerSheetId: self.answerCardId,
          answerSectionId: self.editorMode ? 0 : self.answerSectionId,
          type: self.subjectType,
          title: self.subjectTitle,
          amount: context === "confirm" ? self.subjectAmount : 0,
          score: self.subjectScore * 100,
          colCount: self.colCount,
          blockCount: self.blockCount
        };
      }
      if (this.scoreFlag) {
        _addBigSubject(dataInfo).then(res => {
          if (res.code === 0) {
            self.rankList = res.data;
            if (self.lineSubject == 5 && self.editorMode) {
              self.changeSmallAttr(undefined, 2);
            } else if (self.lineSubject == 5 && !self.editorMode) {
              self.changeSmallAttr(undefined, 3);
            } else {
              self.subjectAmount = 1;
            }
            if (context === "confirm") {
              self.addSubjectStatus = false;
              self.editorMode = false;
            } else {
              self.deleteBigStatus = false;
            }
            self.subjectType = 1;
            self.subjectTitle = "选择题";
            self.subjectScore = 1;
            self.colCount = 4;
            self.blockCount = 1;
            self.lineSubject = -1;
          }
        });
      }
    },
    //   获取大题类型列表
    getQuestionTypeList() {
      const self = this;
      _getQuestionTypeList().then(res => {
        if (res.code === 0) {
          self.subjectTypeList = res.data;
        }
      });
    },
    //      发布答题卡确认
    publishAnswerCard() {
      const self = this;
      let dataInfo = {
        answerSheetId: self.answerCardId,
        headcount: self.txtValue
      };
      _publishAnswerCard(dataInfo).then(res => {
        if (res.code === 0) {
          self.exportStatus = false;
          //            messageAlert('发布成功！','success');
          if (self.rankList.answerCount === 0) {
            setTimeout(function() {
              self.layingCodeStatus = true;
            }, 500);
          } else {
            setTimeout(function() {
              self.$router.back(-1);
            }, 1500);
          }
        }
      });
    },
    //      新增大题弹框显示
    addSubjectFn() {
      this.editorMode = true;
      this.addSubjectStatus = true;
    },
    //      新增、编辑弹框隐藏
    hideSubject() {
      let self = this;
      setTimeout(function() {
        self.subjectType = 1;
        self.subjectTitle = "选择题";
        self.subjectScore = 1;
        self.subjectAmount = 1;
        self.colCount = 4;
        self.blockCount = 1;
        self.lineSubject = -1;
        self.questionIndex = -1;
      }, 100);
      self.editorMode = false;
      self.addSubjectStatus = false;
    },
    //      修改弹框显示
    reviseData(e) {
      this.context = e.target.dataset.context;
      this.txtValue = e.target.dataset.value;
      this.questionIndex = e.target.dataset.index;
      if (/^(name)|(grade)|(subject)$/gi.test(this.context)) {
        this.reviseModalStatus = true;
      } else {
        this.bigIndex = e.target.dataset.index;
        this.answerSectionId = e.target.dataset.answerId;
        this.subjectType = this.rankList.sections[this.bigIndex].type;
        this.subjectTitle = this.rankList.sections[this.bigIndex].title;
        this.subjectAmount = this.rankList.sections[this.bigIndex].amount;
        this.subjectScore = this.rankList.sections[this.bigIndex].score / 100;
        this.colCount = this.rankList.sections[this.bigIndex].colCount;
        this.blockCount = this.rankList.sections[this.bigIndex].blockCount;
        this.addSubjectStatus = true;
        this.lineSubject = this.rankList.sections[this.bigIndex].type;
      }
    },
    //      删除大题
    deleteBigShowModal(e) {
      this.bigIndex = e.target.dataset.index;
      this.answerSectionId = e.target.dataset.answerId;
      this.subjectType = this.rankList.sections[this.bigIndex].type;
      this.subjectTitle = this.rankList.sections[this.bigIndex].title;
      this.subjectAmount = this.rankList.sections[this.bigIndex].amount;
      this.subjectScore = this.rankList.sections[this.bigIndex].score / 100;
      this.colCount = this.rankList.sections[this.bigIndex].colCount;
      this.blockCount = this.rankList.sections[this.bigIndex].blockCount;
      this.deleteBigStatus = true;
    },
    //      显示小题编辑
    showAttrEditor(e) {
      this.bigIndex = e.target.dataset.bigIndex;
      this.smallIndex = e.target.dataset.smallIndex;
      this.questionNo = e.target.dataset.questionNo;
      this.questionOffset = e.target.dataset.questionOffset;
      this.answerSectionId = e.target.dataset.answerId;
      if (!this.answerEditorMode) {
        this.blockTimes = this.rankList.sections[this.bigIndex].details[
          this.smallIndex
        ].colTimes;
        this.blockCount = this.rankList.sections[this.bigIndex].details[
          this.smallIndex
        ].items.length;
        this.rowTimes = this.rankList.sections[this.bigIndex].details[
          this.smallIndex
        ].rowTimes;
        this.smallScore =
          this.rankList.sections[this.bigIndex].details[this.smallIndex].score /
          100;
        //          判断小题高度可调整
        if (
          this.rankList.sections[this.bigIndex].colCount === 1 &&
          this.rankList.sections[this.bigIndex].type === 2
        ) {
          this.rowTimesStatus = true;
        } else if (this.rankList.sections[this.bigIndex].colCount != 1) {
          this.changeWidthStatus = true;
        } else {
          this.rowTimesStatus = false;
          this.changeWidthStatus = false;
        }
        this.attrModalStatus = true;
      } else {
        this.txtValue = this.rankList.sections[this.bigIndex].details[
          this.smallIndex
        ].answer;
        //          this.reviseModalStatus= true;
      }
    },
    //      编辑小题属性确认，或删除该小题
    changeSmallAttr(e, id = 1) {
      const self = this;
      if (id == 1 && e) {
        var context = e.target.dataset.context;
        var dataInfo = {
          answerSheetId: self.answerCardId,
          answerSectionId: self.answerSectionId,
          questionNo: self.questionNo,
          colTimes: self.blockTimes,
          rowTimes: self.rowTimes,
          questionCount: context === "confirm" ? self.blockCount : 0,
          score: self.smallScore * 100
        };
      } else if (id == 2 && !e) {
        var data = self.rankList.sections[self.rankList.sections.length - 1];
        var dataInfo = {
          answerSheetId: self.answerCardId,
          answerSectionId: data.id.toString(),
          questionNo: data.details[0].questionNo,
          colTimes: 1,
          rowTimes: 1,
          questionCount: self.subjectAmount.toString(),
          score: self.subjectScore * 100
        };
      } else if (id == 3 && !e) {
        var dataInfo = {
          answerSheetId: self.answerCardId,
          answerSectionId: self.answerSectionId,
          questionNo:
            self.rankList.sections[self.questionIndex].details[0].questionNo,
          colTimes: 1,
          rowTimes: 1,
          questionCount: self.subjectAmount.toString(),
          score: self.subjectScore * 100
        };
      }
      _changeSmallAttr(dataInfo).then(res => {
        if (res.code === 0) {
          self.attrModalStatus = false;
          if (context === "delete" && self.blockCount > 1) {
            window.location.reload();
          }
          self.rankList = res.data;
          self.blockTimes = 1;
          self.blockCount = 1;
          self.rowTimes = 1;
          self.smallScore = 100;
          self.questionIndex = -1;
        }
      });
    },
    //      添加 答案确认（除判断题）
    editorSmallAnswer(msg) {
      console.log("msg--", msg);
      const self = this;
      let dataInfo = {
        answerSheetId: self.answerCardId,
        answerSectionId: self.answerSectionId,
        questionNo: self.questionNo,
        questionOffset: self.questionOffset,
        answer: msg
      };
      _editorSmallAnswer(dataInfo).then(res => {
        if (res.code === 0) {
          self.rankList = res.data;
          self.reviseModalStatus = false;
          self.txtValue = "";
        }
      });
    },
    //      添加 答案  判断题
    addJudgeAnswer(data) {
      const self = this;
      let answerValue = 0;
      if (data.context === "all") {
        answerValue = data.msg;
        //          let judgmentList = self.rankList.sections[data.bigIndex];
        //          console.log("judgmentList1111----",judgmentList);
        //          judgmentList.details.length > 0 && judgmentList.details.forEach((list,index) => {
        //            if(list.items && list.items.length > 1){
        //              list.items.forEach((item,num) => {
        //                if(num < list.items.length - 1) {
        //                  judgmentList.details.splice(index,0,{
        //                    "answerSheetId": judgmentList.answerSheetId,
        //                    "answerSectionId": judgmentList.id,
        //                    "questionNo": list.questionNo,
        //                    "questionOffset": item.questionOffset,
        //                  })
        //                }else{
        //                  judgmentList.details.splice(index,1);
        //                }
        //              });
        //            }
        //          });
        //          console.log("judgmentList2222----",judgmentList);
        if (self.rankList.sections[data.bigIndex].details.length > 0) {
          //          if (judgmentList.details.length > 0) {
          let dataInfo = {
            answerSheetId: self.rankList.id,
            answerSectionId: self.rankList.sections[data.bigIndex].id,
            questionNo:
              self.rankList.sections[data.bigIndex].details[self.judgeOrderNum]
                .questionNo,
            questionOffset:
              self.rankList.sections[data.bigIndex].details[self.judgeOrderNum]
                .questionOffset,
            answer: answerValue
          };
          _editorSmallAnswer(dataInfo).then(res => {
            if (res.code === 0) {
              self.rankList = res.data;
              self.judgeOrderNum++;
              if (
                self.judgeOrderNum <=
                self.rankList.sections[data.bigIndex].details.length - 1
              ) {
                self.addJudgeAnswer(data);
              } else {
                self.judgeOrderNum = 0;
              }
            }
          });
        }
      } else {
        let alreadyAnswer =
          self.rankList.sections[data.bigIndex].details[data.smallIndex].answer;
        if (alreadyAnswer == 0 || alreadyAnswer == "") {
          answerValue = 1;
        } else if (alreadyAnswer == 1) {
          answerValue = 2;
        } else if (alreadyAnswer == 2) {
          answerValue = 0;
        }
        let dataInfo = {
          answerSheetId: self.rankList.id,
          answerSectionId: self.rankList.sections[data.bigIndex].id,
          questionNo:
            self.rankList.sections[data.bigIndex].details[data.smallIndex]
              .questionNo,
          questionOffset:
            self.rankList.sections[data.bigIndex].details[data.smallIndex]
              .questionOffset,
          answer: answerValue
        };
        _editorSmallAnswer(dataInfo).then(res => {
          if (res.code === 0) {
            self.rankList = res.data;
          }
        });
      }
    },
    //     验证输入的分值，最多两位小数
    checkValue(context) {
      //        attr-属性里修改分数，add-新增，编辑修改分数
      let dealNum =
        context === "add"
          ? this.subjectScore.toString().split(".")
          : this.smallScore.toString().split(".");
      switch (dealNum.length) {
        case 1:
          if (dealNum[0] == 0) {
            this.scoreFlag = false;
            messageAlert("每空得分必须大于零", "warning");
          } else {
            this.scoreFlag = true;
          }
          break;
        case 2:
          if (dealNum[1].length > 2) {
            this.scoreFlag = false;
            messageAlert("得分只精确到小数点后两位", "warning");
          } else {
            this.scoreFlag = true;
          }
          break;
        default:
          this.scoreFlag = false;
          messageAlert("每空得分填写有误", "warning");
      }
    },
    //      input聚焦全选
    selectedALl(e) {
      selectedALLTxt(e);
    },
    //      切换到录入答案模式
    changeAddAnswerMode() {
      this.answerEditorMode = true;
      this.layingCodeStatus = false;
      //        console.log("点击哦了", this.answerEditorMode);
      //        this.$forceUpdate();
    },
    //      切换题目类型
    changeSubjectType(msg) {
      this.lineSubject = msg;
      switch (msg) {
        case 1:
          this.subjectTitle = "选择题";
          this.colCount = 4;
          break;
        case 2:
          this.subjectTitle = "填空题";
          this.colCount = 4;
          break;
        case 3:
          this.subjectTitle = "问答题";
          this.colCount = 1;
          break;
        case 4:
          this.subjectTitle = "判断题";
          this.colCount = 4;
          break;
        case 5:
          this.subjectTitle = "连线题";
          this.subjectAmount = 1;
          break;
        default:
          this.subjectTitle = "选择题";
      }
      //        if(msg === 3) {
      //          this.colCount = 1;
      //        }else{
      //          this.colCount = 4;
      //        }
    },
    //      新增，编辑大题弹框状态监测
    addSubjectStatusChange(boolean) {
      if (!boolean) {
        this.hideSubject();
      }
    },
    //     属性编辑弹框状态检测
    changeAttrSwitch(boolean) {
      if (!boolean) {
        this.blockTimes = 1;
        this.rowTimes = 1;
        this.blockCount = 1;
        this.changeWidthStatus = false;
        this.rowTimesStatus = false;
      }
    },
    //      滚动控制
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector(".card_header").offsetTop;
      if (scrollTop > offsetTop) {
        this.fixedCtrl = true;
      } else {
        this.fixedCtrl = false;
      }
    },
    //选择颜色
    selectColor(count) {
      // this.colorModalStatus = true;
      // this.answerSectionId = answerSectionId;
      // this.questionNo = questionNo;
      // this.questionOffset = questionOffset;
      // let colorLength = this.rankList.sections[index].details[num].items.length;
      // this.colorList = this.initColorList.slice(0, colorLength)
      // this.doingAnswer = this.rankList.sections[index].details[num].items.filter((current,index,arr)=>{
      //   if(current.answer){
      //     return current
      //   }
      // })
      const self = this;
      if (this.activeColor.id == -1 && !this.activeColor.value) {
        return false;
      } else {
        // this.answerSectionId = answerSectionId;
        // this.questionNo = questionNo;
        // this.questionOffset = questionOffset;
        this.activeAnswer = count;
        // self.changeColorModal()
        this.resetAnswer().then(() => {
          self.changeColorModal();
        });
      }
    },
    //重置答案
    resetAnswer() {
      const self = this;
      return new Promise((resolve, reject) => {
        self.rankList.sections[self.rankIndex].details[
          self.detailIndex
        ].items.some((current, index1, arr) => {
          if (current.answer == self.activeAnswer && current.answer != "") {
            let dataInfo = {
              answerSheetId: self.answerCardId,
              answerSectionId: self.answerSectionId,
              questionNo: self.questionNo,
              questionOffset: current.questionOffset,
              answer: ""
            };
            _editorSmallAnswer(dataInfo).then(res => {
              if (res.code === 0) {
                self.rankList = res.data;
                // self.colorModalStatus = false;
                // self.activeColor.id = -1;
                // self.activeColor.value = '';
                resolve();
              }
            });
            return true;
          } else if (
            index1 ==
            self.rankList.sections[self.rankIndex].details[self.detailIndex]
              .items.length -
              1
          ) {
            resolve();
          }
        });
      });
    },
    //点击颜色确认
    changeColorModal() {
      const self = this;
      let dataInfo = {
        answerSheetId: self.answerCardId,
        answerSectionId: self.answerSectionId,
        questionNo: self.questionNo,
        questionOffset: self.questionOffset,
        answer: self.activeAnswer
      };
      _editorSmallAnswer(dataInfo).then(res => {
        if (res.code === 0) {
          self.rankList = res.data;
          // self.colorModalStatus = false;
          self.activeColor.id = -1;
          self.activeColor.value = "";
        }
      });
    },
    //点击选中颜色
    selectActiveColor(id) {
      let status = this.doingAnswer.some((current, index, arr) => {
        return current.answer == id;
      });
      if (!status) {
        this.colorList.some((current, index, arr) => {
          if (current.id == id) {
            this.activeColor.id = id;
            this.activeColor.value = current.value;
          }
        });
      }
    },
    //是否选择颜色
    canChoose(id) {
      let status = this.doingAnswer.some((current, index, arr) => {
        if (current.answer == id) {
          this.canChooseColor = true;
        }
      });
    },
    //退出选择
    outChoose() {
      this.canChooseColor = false;
    },
    //取消选择颜色
    cancelColor() {
      this.colorModalStatus = false;
      this.activeColor.value = "";
      this.activeColor.id = -1;
      this.colorList = this.initColorList;
    },
    //删除当前颜色
    deleteColor() {
      const self = this;
      let dataInfo = {
        answerSheetId: self.answerCardId,
        answerSectionId: self.answerSectionId,
        questionNo: self.questionNo,
        questionOffset: self.questionOffset,
        answer: ""
      };
      _editorSmallAnswer(dataInfo).then(res => {
        if (res.code === 0) {
          self.rankList = res.data;
          self.colorModalStatus = false;
          self.activeColor.id = -1;
          self.activeColor.value = "";
        }
      });
    },
    //监听小题数量变化
    changeSubjectAmount() {
      if (this.subjectType == 5) {
        if (this.subjectAmount > 9) {
          this.subjectAmount = 9;
          messageAlert("最多9个小题", "warning");
        }
      }
    },
    //点击左边的颜色
    getLeftColor(
      answerSectionId,
      questionNo,
      questionOffset,
      count,
      index,
      num
    ) {
      this.activeColor.id = this.colorList[count].id;
      this.activeColor.value = this.colorList[count].value;
      this.answerSectionId = answerSectionId;
      this.questionNo = questionNo;
      this.questionOffset = questionOffset;
      this.rankIndex = index;
      this.detailIndex = num;
    }
  },
  computed: {
    getCurrentColor(id, answer, items) {
      const self = this;
      return function(id, answer, items) {
        var obj = {};
        items.some((firstCurrent, firstIndex, firstArr) => {
          if (id - 1 == firstCurrent.answer && firstCurrent.answer != "") {
            self.colorList.some((current, index, arr) => {
              if (firstCurrent.questionOffset - 1 == current.id) {
                obj = {
                  background: self.colorList[current.id].value
                };
              }
            });
          }
        });
        return obj;
      };
    },
    getCurrentAnswer(id, answer, items, questionNo) {
      const self = this;
      return function(id, answer, items, questionNo) {
        var answer = "";
        items.some((firstCurrent, firstIndex, firstArr) => {
          if (id - 1 == firstCurrent.answer && firstCurrent.answer != "") {
            answer =
              self.rankList.mode === 1
                ? questionNo + "." + firstCurrent.questionOffset
                : firstCurrent.questionOffset;
          }
        });
        return answer;
      };
    },
    setCurrentColor(currentIndex) {
      var obj = {};
      return function(currentIndex) {
        this.colorList.forEach((current, index, arr) => {
          if (currentIndex == index) {
            obj = {
              background: current.value
            };
          }
        });
        return obj;
      };
    }
  },
  created() {
    this.answerCardId = this.$route.query.id;
    this.answerEditorMode = this.$route.query.status === "true" ? true : false;
    this.getQuestionTypeList();
    this.getAnswerCardDetail();
  },
  mounted() {
    const self = this;
    self.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      self.screenWidth = document.body.clientWidth;
    };
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
.test_card {
  width: 100%;
  height: inherit;
  padding: 0 30px;
  box-sizing: border-box;
}

.card_header {
  display: flex;
  height: 62px;
  padding: 11px 0;
  line-height: 40px;
  font-size: 20px;
  color: #333;
}

.card_header > .test_number_info {
  float: left;
  width: 500px;
}

.card_header > .ctrl_btn_wrapper {
  float: right;
  width: 100%;
  text-align: right;
}

.ctrl_btn_wrapper > .ctrl_item {
  display: inline-block;
  width: 150px;
  height: 40px;
  margin-left: 15px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  /*! autoprefixer: off */
  background: -webkit-linear-gradient(left, #04a2ff, #1f76f8);
  /* autoprefixer: on */
  background: -o-linear-gradient(left, #04a2ff, #1f76f8);
  background: -moz-linear-gradient(left, #04a2ff, #1f76f8);
  background: linear-gradient(left, #04a2ff, #1f76f8);
}

.ctrl_btn_wrapper > .ctrl_item:first-child {
  margin-left: 0;
}

.test_number_info > .test_info_item {
  display: inline-block;
  margin-right: 80px;
}

.test_number_info > .test_info_item:last-child {
  margin-right: 0;
}

.card_content {
  min-height: 600px;
  padding: 0 56px;
  background: #fff;
}

.test_caption {
}

.test_caption > .test_title {
  height: 78px;
  padding: 25px 0;
  text-align: center;
  line-height: 28px;
  font-size: 28px;
  color: #333;
}

.test_card .revise {
  display: inline-block;
  margin-left: 10px;
  line-height: 18px;
  font-size: 18px;
  color: #1e77f8;
  cursor: pointer;
}

.test_caption > .subject_grade {
  height: 38px;
  padding: 6px 0;
  text-align: center;
  line-height: 22px;
  font-size: 22px;
  color: #333;
}

.subject_grade > .subject_item {
  display: inline-block;
  margin-right: 100px;
}

.subject_grade > .subject_item:last-child {
  margin-right: 0;
}

.student_info-wrapper {
  padding: 14px 0 10px;
}

.student_info-wrapper > .student_info {
  float: left;
  height: 158px;
  width: 700px;
  padding: 18px 0;
}

.student_info-wrapper > .student_score {
  float: right;
  height: 158px;
}

.student_info > .class_name {
  height: 46px;
  margin-bottom: 30px;
  line-height: 46px;
  font-size: 18px;
  color: #333;
  vertical-align: middle;
}

.class_name > .header_card_border {
  display: inline-block;
  line-height: 46px;
  vertical-align: top;
}

.class_name > .header_card_border {
  display: inline-block;
  width: 210px;
  height: 46px;
  margin-right: 40px;
  border: 1px solid #666;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.student_score > .class_name {
  height: 158px;
  line-height: 158px;
  font-size: 18px;
  color: #333;
  vertical-align: middle;
}

.class_name > .count_label {
  display: inline-block;
  vertical-align: top;
}

.class_name > .count_card_border {
  display: inline-block;
  width: 210px;
  height: 158px;
  border: 1px solid #666;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.first_level {
}

.first_level > .level_title {
  padding: 15px 0;
  line-height: 18px;
  font-size: 18px;
  color: #333;
}

.level_title > .first_level_type {
}

.level_title > .score_value {
  color: #666;
}

.second_level .big_space {
  position: relative;
  /*height: 74px;*/
  padding-right: 10px;
  margin: 22px 0;
  box-sizing: border-box;
  float: left;
  /*display: flex;*/
  /*flex-flow: row wrap;*/
}

.second_level .big_space_nowrap {
  display: flex;
  flex-flow: row wrap;
}

.big_question_space {
  /*position: relative;*/
  display: flex;
  flex-flow: row wrap;
  height: 400px;
  padding-right: 10px;
  margin-bottom: 20px;
  border: 1px solid #333;
  box-sizing: border-box;
  /*float: left;*/
}

.big_question_space_answer {
  /*position: relative;*/
  height: 400px;
  padding-right: 10px;
  margin-bottom: 20px;
  box-sizing: border-box;
  float: left;
  display: flex;
  flex-flow: row wrap;
}

.second_level .last_child {
  margin-right: 0;
}

.big_space .title_num {
  position: absolute;
  left: 4px;
  top: 25px;
}

.big_question_space_answer .title_num,
.big_question_space .title_num {
  position: absolute;
  left: 4px;
  top: 25px;
}

.big_space .small_space {
  height: 74px;
  border: 1px solid #999;
  position: relative;
  margin-bottom: 4px;
  /*flex:1;*/
}

.big_space .small_space_nowrap {
  flex: 1;
}

.small_space .answer_section {
  display: block;
  height: inherit;
  line-height: 74px;
  font-size: 18px;
  color: #3982f8;
  text-align: center;
}

.big_question_space_answer .question_space,
.big_question_space .question_space {
  height: 400px;
  border: 1px solid #999;
  flex: 1;
}

.question_space .answer_section {
  display: block;
  height: inherit;
  padding: 0 70px;
  line-height: 50px;
  font-size: 18px;
  color: #3982f8;
}

.footer_ctrl .footer_btn_item_small {
  padding: 3px 15px;
}

.footer_ctrl .resize_btn_item_small {
  display: inline-block;
  padding: 2px 18px;
  border: 1px solid #1e77f8;
  box-sizing: border-box;
  background: #1e77f8;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
}

.footer_ctrl .resize_cancel_btn {
  border: 1px solid #1e77f8;
  margin-right: 10px;
  background: none;
  color: #1e77f8;
}

.footer_ctrl .resize_delete_btn {
  float: left;
  border: 1px solid #ff0000;
  margin-right: 10px;
  background: none;
  color: #f00;
}

.footer_ctrl > .delete_btn {
  float: left;
}

.footer_ctrl > .confirm_wrapper {
  float: right;
}

.confirm_wrapper01 {
  width: 100%;
}

.confirm_wrapper01 span {
  float: right;
}

.confirm_wrapper01 .resize_btn_item_small01 {
  float: left;
}

/*.export_title {*/
/*line-height: 50px;*/
/*color: #333;*/
/*font-size: 20px;*/
/*text-align: center;*/
/*}*/

.export_tips {
  line-height: 50px;
  padding-bottom: 15px;
  color: #666;
  font-size: 16px;
  text-align: center;
}

.model_item > .total_num {
  width: 50%;
}

.model_item .people_label {
  flex: 0 0 140px;
  width: 140px;
}

.new_second_level {
  display: flex;
  flex-wrap: wrap;
}

.new_detail_level {
  display: flex;
  flex-wrap: wrap;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.new_item_level {
  display: flex;
  /*position: relative;*/
  height: 74px;
  line-height: 74px;
  border: 1px solid #333;
  margin-bottom: 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.new_item_level_answer {
  display: inline-block;
  /*position: relative;*/
  height: 74px;
  line-height: 74px;
  margin-bottom: 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.new_item_level_answer .question_num {
  /*flex: 0 0 30px;*/
  /*width: 100%;*/
  display: flex;
  height: 100%;
  border: 1px solid #666;
  font-size: 16px;
  color: #333;
}

.new_item_level > .question_num_pre {
  display: flex;
  height: 100%;
  font-size: 16px;
  color: #333;
}

.new_item_level_answer .answer_section,
.new_item_level .answer_section {
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 0;*/
  flex: 1;
  width: 100%;
  height: inherit;
  line-height: inherit;
  text-align: center;
  font-size: 18px;
  color: #3982f8;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*padding-left: 20px;*/
}

.new_item_level .answer_section_inside {
  position: absolute;
  flex: 1;
  width: 100%;
  height: inherit;
  line-height: inherit;
  text-align: center;
  font-size: 18px;
  color: #3982f8;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*padding-left: 20px;*/
}

.big_question_space .answer_section {
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 0;*/
  /*display: block;*/
  flex: 1;
  /*width: 100%;*/
  height: inherit;
  line-height: 36px;
  text-align: left;
  font-size: 18px;
  color: #3982f8;
  padding: 0 10px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.big_question_num {
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 0;*/
  /*height: 100%;*/
  display: flex;
  width: 100%;
  border: 1px solid #666;
  line-height: 30px;
  font-size: 16px;
  color: #333;
}

.big_question_num_pre {
  display: flex;
  line-height: 30px;
  font-size: 16px;
  color: #333;
}

.question_right_score {
  /*position: absolute;*/
  /*top: 0;*/
  /*right: 10px;*/
  line-height: 74px;
  font-size: 16px;
  color: #666;
}

.answer_ipt {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 72px;
  /*padding: 0 10px 0 46px;*/
  box-sizing: border-box;
  border: none;
  font-size: 18px;
  color: #3982f8;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.answer_ipt:focus {
  outline: none;
}

.answer_txt {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  border: none;
  font-size: 18px;
  color: #3982f8;
  text-align: center;
  resize: none;
}

.answer_txt:focus {
  outline: none;
}

.order_num {
  display: flex;
  /*position: absolute;*/
  /*left: 4px;*/
  /*top: 0;*/
}

.order_num_small {
}

.order_num_score {
}

.export_title {
  line-height: 36px;
  color: #333;
  font-size: 20px;
  text-align: center;
}

.export_num {
  margin: 30px 0 40px;
}

.model_item > .total_num {
  width: 42%;
}

.model_item .people_label {
  flex: 0 0 200px;
  width: 200px;
  font-size: 18px;
}

.set_answer_tips {
  font-size: 16px;
}

.answer_tips {
  display: inline-block;
  margin-left: 15px;
  font-size: 14px;
  color: #3982f8;
}

.judge_subject {
  display: inline-block;
  margin-left: 25px;
}

.judge_item {
  margin-left: 10px;
}

.judge_icon {
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 0;*/
  width: 100%;
  height: 100%;
  line-height: 74px;
  font-size: 34px;
  text-align: center;
  /*border: 1px solid #999;*/
  box-sizing: border-box;
}

.isFixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  padding: 11px 30px;
  box-sizing: border-box;
  background: #f2f2f2;
}

.footer_ctrl .span_btn {
  display: inline-block;
  height: 30px;
  padding: 0 52px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-left: 12px;
  border-radius: 4px;
  line-height: 30px;
  font-size: 14px;
  background: #2d8cf0;
  color: #fff;
  cursor: pointer;
}

.footer_ctrl .cancel_btn {
  background: #fff;
  border: 1px solid #2d8cf0;
  color: #2d8cf0;
}

.page_division_line {
  position: absolute;
  left: 30px;
  /*height:88px;*/
  border-bottom: 2px solid #ccc;
}

.line-box {
  width: 100%;
  margin-bottom: 15px;
}

.line-subject {
  height: 74px;
  line-height: 74px;
  border: 1px solid #000;
  width: 30%;
  color: #000;
  font-size: 18px;
  box-sizing: border-box;
}

.line-left {
  float: left;
}

.line-right {
  float: right;
}

.color-list {
  padding: 10px;
}

.color-box {
  width: 114px;
  height: 40px;
  border-radius: 5px;
  float: left;
  margin-right: 57px;
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;
}

.color-list .color-box:nth-child(3n) {
  margin-right: 0;
}

.active-color {
  width: 26px;
  height: 26px;
  /*background: url("../assets/wanchengshijian.png") no-repeat center;*/
  background-size: contain;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -13px;
}

.set-answer {
  cursor: pointer;
}

.not-select {
  cursor: not-allowed;
}

.show-answer {
  text-align: center;
}

.level_title .revise01 {
  cursor: inherit;
  color: #000;
}

.inside_line_wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.partition_line_inside {
  display: block;
  border-bottom: 1px dashed #999;
}
</style>



// WEBPACK FOOTER //
// src/components/MakeTestCard.vue